var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGtoLogoGreenDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3193_9581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3297 13.0645L15.347 13.0535L15.3291 13.0442L15.3297 13.0645Z",
    fill: "#5CB335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3555 21.5782H25.0953L22.7301 25.606H17.9903L20.3555 21.5782ZM0.463766 13.006L2.83394 8.98093L5.20914 13.0033L2.83896 17.0284L0.463766 13.006ZM15.1709 12.9031L17.2598 8.98203L12.9743 8.97108L7.88458 0.403275H12.6244L17.7208 8.98367H17.713L15.5565 13.0317L17.9044 16.6317L20.0519 13.006H30.1454L27.7752 17.03H17.6678L17.6767 17.0152L15.2518 13.2966L10.7916 13.3836L12.9257 17.0289L7.89351 25.5984L5.52334 21.5733L10.5611 12.9962V12.994H10.5623V12.9929L10.5634 12.994L15.1703 12.9042L15.1709 12.9031ZM17.9942 0.399444L22.7346 0.393973L25.1048 4.41851L20.3644 4.42398L17.9942 0.399444ZM17.7626 0L15.3071 4.17009L12.9726 0.206288L12.8565 0.00930213H7.65242L7.53634 0.206288L5.16616 4.23137L5.05008 4.42836L5.16616 4.62535L7.49839 8.58587H2.60178L2.4857 8.78285L0.116081 12.8074L0 13.0044L0.116081 13.2014L2.48626 17.2264L2.60234 17.4234H7.50285L5.17565 21.3752L5.05957 21.5722L5.17565 21.7692L7.54583 25.7943L7.66191 25.9912H12.866L12.9821 25.7943L15.3071 21.8458L17.6376 25.8036L17.7537 26.0005H22.9578L23.0739 25.8036L25.4441 21.7785L25.5602 21.5815L25.4441 21.3845L23.1118 17.4234H28.0085L28.1245 17.2264L30.4947 13.2014L30.6108 13.0044L30.4947 12.8074L28.1245 8.7823L28.0085 8.58532H23.1163L25.4541 4.6155L25.5702 4.41851L25.4541 4.22153L23.0828 0.196986L22.9667 0H17.7626Z",
    fill: "#5CB335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6289 0V0.131871H24.9386V1.02597H25.081V0.131871H25.3907V0H24.6289ZM26.3511 0L26.0392 0.821323L25.7272 0H25.5497V1.02597H25.6921V0.217779L25.9884 1.02597H26.09L26.3863 0.231459V1.02597H26.5269V0H26.3517H26.3511Z",
    fill: "#5CB335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3193_9581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.6097,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGtoLogoGreenDark);
export default __webpack_public_path__ + "static/media/gto-logo-green-dark.f50202ea04822a0bd25484356276ef2a.svg";
export { ForwardRef as ReactComponent };